import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Briefcase, Target, Rocket, Star, UserSearch } from 'lucide-react';
import { IntelligenceLayout } from './IntelligenceLayout';
import NicheLanes from './NicheLanes';
import WeeklyTargets from './WeeklyTargets';
import GrowthExpansionView from './GrowthExpansionView';
import CompanyWatchlist from './CompanyWatchlist';
import EnrichmentQueue from './EnrichmentQueue';

const TABS = [
  { key: 'niche-lanes', label: 'Priority Accounts', icon: Briefcase, Component: NicheLanes },
  { key: 'weekly-targets', label: 'Weekly Targets', icon: Target, Component: WeeklyTargets },
  { key: 'expansion-signals', label: 'Growth & Expansion', icon: Rocket, Component: GrowthExpansionView },
  { key: 'watchlist', label: 'Watchlist', icon: Star, Component: CompanyWatchlist },
  { key: 'enrich-queue', label: 'Enrichment Queue', icon: UserSearch, Component: EnrichmentQueue },
];

const DEFAULT_TAB = 'niche-lanes';

export default function OpportunityPriorityHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(
    TABS.some(t => t.key === requestedTab) ? requestedTab : DEFAULT_TAB
  );

  const handleTabClick = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  const ActiveComponent = TABS.find(t => t.key === activeTab)?.Component || NicheLanes;
  const extraProps = activeTab === 'expansion-signals'
    ? { initialMode: searchParams.get('mode') || 'expansion' }
    : {};

  return (
    <IntelligenceLayout title="Opportunity Priority">
      <div className="border-b border-gray-200 bg-white px-6 pt-4 sticky top-0 z-10" data-testid="opportunity-priority-hub-tabs">
        <div className="flex items-center gap-1 overflow-x-auto">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => handleTabClick(tab.key)}
              data-testid={`opp-priority-tab-${tab.key}`}
              className={`flex items-center gap-1.5 px-3.5 py-2.5 text-sm font-medium rounded-t-lg border-b-2 whitespace-nowrap transition-colors ${
                activeTab === tab.key
                  ? 'text-[#0A1F44] border-[#D4AF37] bg-[#fdf9ef]'
                  : 'text-gray-500 border-transparent hover:text-[#0A1F44] hover:bg-gray-50'
              }`}
            >
              <tab.icon className="h-3.5 w-3.5" />
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <ActiveComponent embedded {...extraProps} />
    </IntelligenceLayout>
  );
}
